import useTableFilters from "@/hooks/useTableFilters";
import SelectStatus from "components/select/status";
import { FilterActions } from "components/filter/actions";
import FilterWrapper from "components/filter/wrapper";
import FiltersList from "components/filter/list";
import { useFetch } from "@/hooks/useFetch";
import { fetchTicketPriority, fetchTicketTypes } from "./api";
import CommonSelect from "components/select";
import UserCombobox from "components/directus/combobox/user";
import { EMPLOYEE_FILTERS } from "components/employee/constants";

export default function TicketsFilters({
  filters,
  setFilters,
  setIsOpen,
  isOpen,
  defaultFilters,
  clearFilters,
}) {
  const {
    localFilters,
    applyFilters,
    clearLocalFilters,
    handleSetLocalFilters,
  } = useTableFilters({
    filters,
    setFilters,
    setIsOpen,
    clearFilters,
    initialFilters: {
      status: undefined,
    },
  });

  const { data: ticketTypes } = useFetch({
    queryKey: ["ticket-types"],
    queryFn: fetchTicketTypes,
  });
  const { data: ticketPriority } = useFetch({
    queryKey: ["ticket-priority"],
    queryFn: fetchTicketPriority,
  });

  return (
    <FiltersList>
      <UserCombobox
        label="Assigned To"
        value={localFilters?.assigned_to?._eq}
        onChange={(selectedItem) => {
          handleSetLocalFilters({
            assigned_to: selectedItem ? { _eq: selectedItem } : undefined,
          });
        }}
        filter={EMPLOYEE_FILTERS.all}
        dependenton={isOpen}
      />

      <FilterWrapper label="Priority">
        <CommonSelect
          placeholder="Select"
          value={localFilters?.priority?._eq}
          onValueChange={(selectedItem) =>
            handleSetLocalFilters({
              priority: {
                _eq: selectedItem?.id,
                __selectedItem: selectedItem,
              },
            })
          }
          items={ticketPriority}
          className="!w-full"
        />
      </FilterWrapper>

      <FilterWrapper label="Type">
        <CommonSelect
          placeholder="Select"
          value={localFilters?.type?._eq}
          onValueChange={(selectedItem) =>
            handleSetLocalFilters({
              type: { _eq: selectedItem?.id, __selectedItem: selectedItem },
            })
          }
          items={ticketTypes}
          className="!w-full"
        />
      </FilterWrapper>

      <FilterWrapper label="Status">
        <SelectStatus
          collection="tickets"
          value={localFilters?.status?._eq}
          onChange={(selectedItem) => {
            handleSetLocalFilters({
              status: { _eq: selectedItem },
            });
          }}
        />
      </FilterWrapper>

      <FilterActions
        applyFilters={applyFilters}
        clearLocalFilters={clearLocalFilters}
      />
    </FiltersList>
  );
}
